<h1 id="main-heading" class="sr-only" tabindex="-1" aria-hidden="false">Resource Routing Queue</h1>
<div class="mb-4 flex justify-end">
  <app-table-action-buttons
    [isLoading]="isLoading"
    (clearFilters)="clearFilters()"
    (fetchTableData)="fetchTableData()"
  />
</div>

<p-table
  #table
  class="block table-height-reduced-50"
  rowExpandMode="single"
  currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
  [styleClass]="'table-expand'"
  [dataKey]="dataKey"
  [totalRecords]="totalRecords"
  [scrollable]="true"
  [scrollHeight]="'flex'"
  [lazy]="true"
  [paginator]="true"
  [filterDelay]="500"
  [rowsPerPageOptions]="[5, 10, 20]"
  [value]="queue$ | async"
  [columns]="columnConfig"
  [showCurrentPageReport]="true"
  [resizableColumns]="true"
  [loading]="isLoading"
  [sortField]="'routedDate'"
  [(first)]="first"
  [(rows)]="rowsPerPage"
  (onLazyLoad)="fetchTableData($event)"
  (onRowExpand)="getExpandedData($event.data[dataKey])"
>
  <ng-template #header>
    <tr>
      @for (column of columnConfig; track column) {
      <th [style]="column.styles" [pSortableColumn]="column.dataKey" [pSortableColumnDisabled]="!column.isSortable">
        <div class="flex items-center">
          {{ column.name }}
          @if (column.isSortable) {
          <p-sortIcon class="p-2" [field]="column.dataKey" />
          }
        </div>
      </th>
      }
    </tr>
    <tr class="header-filter">
      @for (column of columnConfig; track column) {
      <th>
        @switch (column.filterOptions?.template) { @case ('autoComplete') {
        <ng-container *ngTemplateOutlet="autoComplete; context: { $implicit: column }" />
        } @case ('multiselect') {
        <ng-container *ngTemplateOutlet="multiselect; context: { $implicit: column }" />
        } }
      </th>
      }
    </tr>
  </ng-template>
  <ng-template let-item let-expanded="expanded" #body>
    <tr [pSelectableRow]="item" [ngClass]="{ 'row-expanded': expanded }">
      @for (column of columnConfig; track column) {
      <td>
        @switch (column.dataKey) { @case ('expand') {
        <ng-container class="w-full text-center">
          <button
            type="button"
            class="p-button-text p-button-rounded"
            pButton
            aria-label="Toggle details"
            [attr.aria-expanded]="expanded"
            [pRowToggler]="item"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          ></button>
        </ng-container>
        } @case (['memberName', 'serviceLineStatusReason'].includes(column.dataKey) ? column.dataKey : '') {
        <!-- TODO truncate class should be removed after migration to new ui lib -->
        <div class="truncate-child relative">
          <div class="overflow" [title]="item[column.dataKey]">
            {{ item[column.dataKey] }}
          </div>
        </div>
        } @case ('routedDate') {
        {{ item.routedDate | timeSpent }}
        } @default {
        {{ item[column.dataKey] }}
        } }
      </td>
      }
    </tr>
  </ng-template>
  <ng-template #expandedrow>
    <tr class="not-hower-row">
      <td class="p-4" [attr.colspan]="columnConfig.length + 1">
        <app-table-expanded-view [tabs]="tabs" [data]="queueEvaluation$ | async" />
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr class="empty-message">
      <td [attr.colspan]="columnConfig.length + 1">No records found</td>
    </tr>
  </ng-template>
</p-table>

<ng-template #multiselect let-columnConfig>
  <p-multiSelect
    styleClass="w-full"
    placeholder="Filter"
    appendTo="body"
    [resetFilterOnHide]="true"
    [ngModel]="table.filters[columnConfig.dataKey]?.value"
    [options]="(dropdownOptions$ | async)?.[columnConfig.referenceKey || columnConfig.dataKey]"
    (onChange)="table.filter($event.value, columnConfig.dataKey, 'in')"
  />
</ng-template>

<ng-template #autoComplete let-columnConfig>
  <div class="relative">
    <div class="search-icon absolute" (click)="autoCompleteInput.focusInput()">
      <i class="pi pi-search"></i>
    </div>
    <p-autoComplete
      #autoCompleteInput
      appendTo="body"
      delay="500"
      placeholder="Search"
      [suggestions]="filtersData"
      [showEmptyMessage]="true"
      [optionLabel]="columnConfig.dataKey"
      [showClear]="true"
      [minQueryLength]="3"
      [(ngModel)]="filtersText[columnConfig.dataKey]"
      (completeMethod)="fetchSuggestions($event.query, columnConfig.dataKey)"
      (onSelect)="onAutocompleteSelect($event, columnConfig.dataKey)"
      (onClear)="onClearAutocomplete(columnConfig.dataKey)"
    >
      <ng-template let-suggestion #item>
        <div class="max-w-[25rem] text-truncate">
          {{ suggestion[columnConfig.dataKey] }}
        </div>
      </ng-template>
    </p-autoComplete>
  </div>
</ng-template>
